/**
 * Angular Specific
 */
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

/**
 * Features
 */
import { AppMaterialModule } from "../../../app-material.module";
import { AppAutocompleteComponent } from "./autocomplete.component";

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    RouterModule,
    MatIconModule,
    AppMaterialModule,
    ReactiveFormsModule,
  ],
  declarations: [AppAutocompleteComponent],
  exports: [AppAutocompleteComponent],
})
export class AppAutocompleteModule {}
